var _g, _path, _path2, _g2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-1_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1788FB",
  d: "M30 60c16.569 0 30-13.431 30-30C60 13.432 46.569 0 30 0 13.432 0 0 13.432 0 30c0 16.569 13.432 30 30 30"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F1DCC2",
  d: "m21.933 46.762-1.81-9.628c-2.136 2.229-4.271.186-4.643-.186-.371-.371-2.229-2.6-1.021-4.829 1.207-2.228 3.9-1.021 3.9-1.021l-2.043-8.357c-.937-12.715 16.9-9.007 16.9-9.007s6.933 3.327 9.564 6.685c2.988 3.814-2.986 4.958-2.986 4.958 4.937 7.783-.913 13.149-3.73 17.633-1.687 2.685-1.41 4.093-1.41 4.093s.683.693.59 1.158c-.092.464-7.382 1.439-8.589 1.068s-4.217.115-4.722-2.568"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#171717",
  d: "M28.464 23.11a.99.99 0 1 0 0-1.98.99.99 0 0 0 0 1.98M33.664 20.232a.99.99 0 1 0 0-1.981.99.99 0 0 0 0 1.98"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-1_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5C400",
  d: "m34.655 47.103-12.722-.342c.39 2.122.569 6.915.634 12.378 2.37.602 4.854.924 7.412.924 4.277 0 8.34-.9 12.022-2.513-1.167-3.07-3.288-6.932-7.346-10.447"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#171717",
  d: "M33.215 13.734s4.232-1.986 5.572.734-2.012-8.987-7.444-5.82c0 0-.17-1.17.634-1.376.805-.207-2.786-.07-2.91 2.203 0 0-.556-1.377 0-1.79.558-.413-3.528 0-4.395 2.41 0 0-7.614-2.41-12.566 2.342 0 0 2.229.275 1.424 3.787 0 0-1.3 2.238 0 4.15 1.3 1.91 1.725 12.562 5.819 12.562 5.076 0-1.486-4.834-2.476-11.015 0 0 12.034-8.714 16.342-8.187"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-1_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})))));
export { SvgAvatar1 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-1.4dfc95cc34d246cc094a.svg";